import React, { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import ServicePageTemplate from "../components/services/ServicePageTemplate";
import { getMediaServiceBySlug } from "../data/mediaServices";

const ServiceDetailPage = () => {
  const { serviceSlug } = useParams();
  const service = getMediaServiceBySlug(serviceSlug);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [serviceSlug]);

  return service ? <ServicePageTemplate service={service} /> : <Navigate to="/media-services" replace />;
};

export default ServiceDetailPage;
